import { chathistoryConstants } from '../constants';

const initialState = {
    loading: false,
    error: null
};

const chathistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case chathistoryConstants.FETCH_ACTIVECLASSES_REQUEST:
            return {
                ...state,
                loading: true
            };
        case chathistoryConstants.FETCH_ACTIVECLASSES_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case chathistoryConstants.FETCH_ACTIVECLASSES_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        default:
            return state;
    }
};

export default chathistoryReducer;
